import DownloadIcon from 'mdi-react/DownloadIcon'
import { useDispatch, useSelector } from 'react-redux'

import Button from '@/components/form/Button'
import { FilterInput } from '@/components/form/Input'
import { useText } from '@/components/i18n/hooks'
import { Translation } from '@/components/i18n/Translation'
import Hits from '@/components/primitives/Hits'
import {
  getCsvExportData,
  getIsDataLoaded,
  getNumberOfOrders,
  getTextFilter,
  setTextFilter,
} from '@/ducks/deviceOrdersReducer'
import { useLocalDate } from '@/hooks/use-local-date'
import { csvExport } from '@/util/csv-export'

import StatusSelect from './StatusSelect'
import StatusTabs from './StatusTabs'

import './device-order-filter.scss'

const DeviceOrderFilter = () => {
  const dispatch = useDispatch()
  const { formatDate } = useLocalDate()
  const textFilter = useSelector(getTextFilter)
  const numberOfResults = useSelector(getNumberOfOrders)
  const iIsDataLoaded = useSelector(getIsDataLoaded)

  const productFilterPlaceholderText = useText('filter orders')

  const csvExportData = useSelector(getCsvExportData)
  // @ts-ignore
  const updateValue = e => {
    dispatch(setTextFilter(e.target.value))
  }

  return (
    iIsDataLoaded && (
      <div className="device-order-filter">
        <StatusTabs />

        <StatusSelect />

        <FilterInput
          type="text"
          placeholder={productFilterPlaceholderText}
          value={textFilter}
          onChange={updateValue}
        />

        <Button
          onClick={() =>
            csvExport(csvExportData, `device-orders_${formatDate({ date: new Date() })}.csv`)
          }
          Icon={DownloadIcon}
        >
          <Translation id="Export data" />
        </Button>

        <Hits amount={numberOfResults} />
      </div>
    )
  )
}

export default DeviceOrderFilter
